<template>
    <div>
      <Header></Header>
      <div class="mains">
        <router-view></router-view>
      </div>
      <object class="obj-footer" data="/web/Common/snippet/footer.html?json=%7B%22contacts%22%3A%5B%7B%22name%22%3A%22%E5%A4%96%E8%B4%B8%E4%BC%81%E4%B8%9A%E4%BF%A1%E6%81%AF%E7%AE%A1%E7%90%86%22%2C%22value%22%3A%5B%22010-67801607%22%2C%22010-67801960%22%5D%7D%2C%7B%22name%22%3A%22%E5%A4%96%E7%B1%8D%E4%BA%BA%E6%89%8D%E7%B3%BB%E7%BB%9F%22%2C%22value%22%3A%5B%22010-67801607%22%5D%7D%5D%7D"></object>
    </div>
</template>
<script>
import Header from '@/components/HomeHeader'
export default {
  components: {
    Header
  },
  // props: {
  // '': {
  //    type:Object|Array|String|Boolean|Number
  //  }
  // },
  data () {
    return {
    }
  },
  methods: {
    // 新增
    add_data () {
    },
    // 查询数据
    search_data (row, type) {
      Object.assign(this.matterParams, row)
      this.Render()
    },
    // 列表按钮
    event_button (row, type) {
    },
    // 列表数据
    Render () {
    }
  },
  created () {
    this.Render()
  },
  watch: {
  },
  mounted () {
  }
}
</script>
<style lang="scss" scoped>
 .mains{
    overflow: hidden;
    margin: 0 auto;
    width: 1200px;
    background: #fff;
    min-height: calc(100vh - 300px);
  }
</style>
